import { throttle } from 'lodash';
import { keywordFilter } from './search.history';
import { SearchHelper } from './search.helper';

export default class InstantSearch extends SearchHelper {
  constructor($wrapper, searchHistory = null) {
    super($wrapper);

    this.isInstantSearchOpen = false;
    this.keyword = '';
    this.timestamp = 0;
    this.searchHistory = searchHistory;

    this.setEvents();
  }

  setEvents() {
    if (this.useHighlight) {
      this.$wrapper.on('mouseover', '.searched_book_item, .searched_writer_item', throttle(e => {
        e.preventDefault();
        this.setHighlightAt($(e.currentTarget).data('index'), this.$wrapper.find('.highlight'));
      }, 100));
    }
  }

  isOpen() {
    return this.isInstantSearchOpen && this.$wrapper.html().length > 0;
  }

  open() {
    this.$wrapper.show();
    this.isInstantSearchOpen = true;
  }

  close() {
    this.$wrapper.hide();
    this.isInstantSearchOpen = false;
    if (this.useHighlight) this.setHighlightAt(-1, this.$wrapper.find('.highlight'));
  }

  reset() {
    this.keyword = '';
    this.$wrapper.html('');
    this.timestamp = $.now();
  }

  get(newKeyword) {
    if (newKeyword === this.keyword) return;
    if (($.now() - this.timestamp < 100)) return;

    this.keyword = newKeyword;

    const map = {
      q: newKeyword,
      instant: 1,
      timestamp: $.now(),
    };

    $.get('/search/', map, (returnHtml, textStatus, jqXHR) => {
      const ts = parseInt(jqXHR.getResponseHeader('x-search-timestamp'), 10);
      if (ts < this.timestamp) return;
      if (returnHtml.length) {
        this.$wrapper.html(returnHtml);
      } else {
        this.$wrapper.html('');
      }
      this.$wrapper.find('a').on('click touchstart', e => {
        e.stopPropagation();
        const $title = ($(e.currentTarget).find('.book_title').length > 0) ? $(e.currentTarget).find('.book_title') : $(e.currentTarget).find('.author_name');
        if (this.searchHistory) this.searchHistory.add(keywordFilter($title.text()));
      });
      this.timestamp = ts;
    }, 'html');
  }

  openSelectedLink() {
    if (!this.useHighlight) return true;
    const $currentSelected = this.$wrapper.find('.highlight');
    if (!$currentSelected.length) return true;
    window.location.href = $currentSelected.find('a').attr('href');
    return false;
  }

  getUpperBound() {
    return $('.searched_writer_item').length + $('.searched_book_item').length;
  }
}



// WEBPACK FOOTER //
// ./common/search.instant.js